import ROLES from './roles.constants'
import { UpdateRolesPayload } from './roles.interface'

const updateRoles = (payload: UpdateRolesPayload) => {
  return {
    type: ROLES.UPDATE_ROLES,
    ...payload
  }
}

const setViewingAsAdmin = () => {
  return {
    type: ROLES.SET_VIEWING_AS_ADMIN
  }
}
const setViewingAsUser = () => {
  return {
    type: ROLES.SET_VIEWING_AS_USER
  }
}
const rolesActions = {
  updateRoles,
  setViewingAsAdmin,
  setViewingAsUser
}

export default rolesActions
